export default __webpack_public_path__ + "static/media/about2title1.696c671c.png";